import { Component, inject, OnChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { GuruEntity } from '../../../model/guru-entity';
import { ModelService } from '../../../services/model-service';
import { UserStateService, ConfigurationSection } from '../../../services/user-state.service';
import { SelectionUtils } from '../../selection-utils';

@Component({
  selector: 'app-air-handler-unit-access-module',
  imports: [FormsModule, MatIcon],
  templateUrl: './air-handler-unit-access-module.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './air-handler-unit-access-module.component.css',
})
export class AirHandlerUnitAccessModuleComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);
  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  accessSelection!: GuruEntity;
  secondaryAccessSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.ACCESS_MODULE;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.accessSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USACS');
    this.secondaryAccessSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSecACS');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }
}
